// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"B8-z"};